export const setGlobal = payload => async dispatch => {
  dispatch({
    type: 'SET_GLOBALS',
    payload,
  });
};

export const setGlobalIsBoxTab = body => async dispatch => {
  dispatch({
    type: 'SET_IS_BOX_TAB',
    payload: body,
  });
};

export const resetGlobalIsBoxTab = () => async dispatch => {
  dispatch({
    type: 'REST_GLOBALS_TO_DEFAULT',
  });
};
